import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Voor welk object wilt u een servicemelding aanmaken? "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Contactpersoon "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Telefoonnummer contactpersoon "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("E-mailadres contactpersoon "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Onderwerp "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Omschrijving "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Afbeeldingen", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Velden gemarkeerd met "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-label" }, "*"),
  /*#__PURE__*/_createTextVNode(" zijn verplicht!")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Procedure nazorg", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Privacybeleid", -1)

import { computed, ref, watch } from 'vue'
import SecureLS from 'secure-ls'
import { authStore } from '@/stores/auth'
import axios from 'axios'
import { Question } from '@/types/Question'
import Uploader from '@/components/Uploader.vue'
import UploadQueue from '@/components/UploadQueue.vue'
import TextEditor from '@/components/TextEditor.vue'
import Banner from '@/components/Banner.vue'
import { notification } from 'ant-design-vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionCreate',
  setup(__props) {

const auth = authStore()
const router = useRouter()
const saving = ref(false)

const buildings = ref(new SecureLS({ isCompression: false }).get('buildings'))

const question = ref<Question>({
  project_id: auth.multipleObjects ? null : buildings.value[0].project_id,
  building_id: auth.multipleObjects ? null : auth.buildingIds[0],
  title: null,
  description: null,
  files: [],
  user_id: auth.user.id,
  contact_name: auth.user.firstname + ' ' + auth.user.lastname,
  contact_phone: auth.user.phone,
  contact_email: auth.user.email,
  source: 'tenant-portal'
})

watch(() => question.value.building_id, (buildingID) => {
  buildings.value.forEach((building:{ id:number, project_id:number }) => {
    if (building.id === buildingID) {
      question.value.project_id = building.project_id
    }
  })
})

const agreedToTerms = ref(false)
const allRequiredFieldsCompleted = computed(() => {
  return (
    question.value.building_id !== null &&
    question.value.title !== null &&
    question.value.description !== null &&
    question.value.contact_name !== null &&
    question.value.contact_phone !== null &&
    question.value.contact_email !== null
  )
})

function newFileUploaded (file:{ name:string, url:string }) : void {
  question.value.files.push(file)
}

function fileDeleted (index:number) : void {
  question.value.files.splice(index, 1)
}

function createQuestion () : void {
  saving.value = true
  axios.post(process.env.VUE_APP_API_URL + '/questions', question.value).then(() => {
    notification.success({
      message: 'Vraag aangemaakt.',
      description: 'Uw vraag is aangemaakt. U ontvangt zo spoedig mogelijk bericht.',
      duration: 5
    })
    router.push('/')
  }).catch(() => {
    notification.error({
      message: 'Vraag NIET aangemaakt!',
      description: 'Uw vraag is NIET aangemaakt. Probeer het later nogmaals.',
      duration: 0
    })
  }).finally(() => {
    saving.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Vraag toevoegen",
            bordered: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createVNode(_component_a_select, {
                        style: {"width":"100%"},
                        value: question.value.building_id,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((question.value.building_id) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildings.value, (building) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              value: building.id,
                              key: building.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(building.address) + ", " + _toDisplayString(building.zipcode) + " " + _toDisplayString(building.city), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: question.value.contact_name,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((question.value.contact_name) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: question.value.contact_phone,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((question.value.contact_phone) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: question.value.contact_email,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((question.value.contact_email) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: question.value.title,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((question.value.title) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createVNode(TextEditor, {
                        onContentChange: _cache[5] || (_cache[5] = ($event: any) => (question.value.description = $event))
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(Uploader, {
                        base64: true,
                        onNewFileUploaded: newFileUploaded
                      }),
                      (question.value.files.length)
                        ? (_openBlock(), _createBlock(UploadQueue, {
                            key: 0,
                            "media-items": question.value.files,
                            onFileDeleted: fileDeleted
                          }, null, 8, ["media-items"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: agreedToTerms.value,
                        "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((agreedToTerms).value = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ja ik ga akkoord met het doorgeven van mijn persoonsgegevens aan de klacht oplossende onderaannemer of leverancier, "),
                          _hoisted_9,
                          _createTextVNode(" & het "),
                          _hoisted_10,
                          _createTextVNode(".")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        loading: saving.value,
                        disabled: !agreedToTerms.value || !_unref(allRequiredFieldsCompleted),
                        onClick: createQuestion
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Vraag insturen")
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})